const linkNavi = document.querySelector('.link_navi');
const linkBergainsNavi = document.querySelector('.link_bergains_navi');
const linkCosmeticsNavi = document.querySelector('.link_cosmetics_navi');
const dropdownWrapper = document.querySelector('.navigationdropdown__wrapper.desktop_nav');
const dropdownInner = document.querySelector('.navigationdropdown__inner');
const dropdownContents = document.querySelector('.navigationdropdown__wrapper.desktop_nav .categorieslist__contents');
const dropdownOverlay = document.querySelector('.navigationdropdown__overlay');
const headerLinks = document.querySelectorAll('.header__nav-trigger');
const isDesktop = () => window.matchMedia('(min-width: 1024px)').matches;
const forceAllProductsDropdown = false;
const forceBergainsDropdown = false;
const forceCosmeticsDropdown = false;
const forcedDesktopCollection = '';
// Dostępne opcje:
// 'cialo' / 'ciało'
// 'dlonie-i-stopy' / 'dłonie i stopy'
// 'golenie'
// 'twarz'
// 'suplementy'
// 'higiena-intymna-i-seks' / 'higiena intymna i seks'
// 'makijaz' / 'makijaż'
// 'prezenty'
let headerHideTimeout;

const normalizeCollectionBaseUrl = (rawUrl) => {
  try {
    const url = new URL(rawUrl, window.location.origin);
    return url.pathname;
  } catch (error) {
    return rawUrl;
  }
};

const normalizeCollectionKey = (value) =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[ąćęłńóśźż]/g, (char) => {
      const polishCharsMap = {
        ą: 'a',
        ć: 'c',
        ę: 'e',
        ł: 'l',
        ń: 'n',
        ó: 'o',
        ś: 's',
        ź: 'z',
        ż: 'z',
      };

      return polishCharsMap[char] || char;
    })
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const forcedDesktopCollectionHandles = {
  cialo: ['pielegnacjaciala', 'cialo'],
  'dlonie-i-stopy': ['dlonie-i-stopy', 'dlonieistopy'],
  golenie: ['golenie-ciala-i-twarzy', 'golenie'],
  twarz: ['pielegnacjatwarzy', 'twarz'],
  suplementy: ['suplementy'],
  'higiena-intymna-i-seks': ['higiena-intymna-i-seks', 'higiena-intymna', 'seks'],
  makijaz: ['makijaz'],
  prezenty: ['prezenty'],
};

const getForcedDesktopCollectionHandles = () => {
  const normalizedCollectionKey = normalizeCollectionKey(forcedDesktopCollection);
  return forcedDesktopCollectionHandles[normalizedCollectionKey] || [];
};

const hasForcedDesktopCollection = () => getForcedDesktopCollectionHandles().length > 0;

const showDesktopDropdown = (hideSidebar) => {
  if (!dropdownWrapper || !isDesktop()) {
    return;
  }
  if (hideSidebar) {
    dropdownWrapper.classList.add('navigationdropdown__wrapper--no-sidebar');
  } else {
    dropdownWrapper.classList.remove('navigationdropdown__wrapper--no-sidebar');
  }
  dropdownWrapper.classList.remove('navigationdropdown__wrapper--hidden');
};

const setAllProductsState = (isAllProducts) => {
  if (!dropdownContents) {
    return;
  }
  dropdownContents.classList.toggle('all-products', Boolean(isAllProducts));
  if (isAllProducts) {
    dropdownContents.classList.remove('bergains-active', 'cosmetics-active');
  }
};

const setBergainsState = (isBergains) => {
  if (!dropdownContents) {
    return;
  }
  dropdownContents.classList.toggle('bergains-active', Boolean(isBergains));
  if (isBergains) {
    dropdownContents.classList.remove('all-products', 'cosmetics-active');
  }
};

const setCosmeticsState = (isCosmetics) => {
  if (!dropdownContents) {
    return;
  }
  dropdownContents.classList.toggle('cosmetics-active', Boolean(isCosmetics));
  if (isCosmetics) {
    dropdownContents.classList.remove('all-products', 'bergains-active');
  }
};

const forceDesktopAllProductsDropdown = () => {
  if (!dropdownWrapper || !dropdownContents || !isDesktop()) {
    return false;
  }
  showDesktopDropdown(true);
  setAllProductsState(true);
  dropdownWrapper.classList.add('navigationdropdown__wrapper--force-visible');
  return true;
};

const forceDesktopBergainsDropdown = () => {
  if (!dropdownWrapper || !dropdownContents || !isDesktop()) {
    return false;
  }
  showDesktopDropdown(true);
  setBergainsState(true);
  hideAllCollectionContainers();
  dropdownWrapper.classList.add('navigationdropdown__wrapper--force-visible');
  return true;
};

const forceDesktopCosmeticsDropdown = () => {
  if (!dropdownWrapper || !dropdownContents || !isDesktop()) {
    return false;
  }
  showDesktopDropdown(true);
  setCosmeticsState(true);
  hideAllCollectionContainers();
  dropdownWrapper.classList.add('navigationdropdown__wrapper--force-visible');
  return true;
};

const activateContainerByCollectionKey = (collectionKey) => {
  if (!dropdownWrapper || !collectionKey) {
    return false;
  }

  const allowedHandles = forcedDesktopCollectionHandles[normalizeCollectionKey(collectionKey)] || [
    normalizeCollectionKey(collectionKey),
  ];
  const containers = Array.from(dropdownWrapper.querySelectorAll('.collection-container'));
  const targetContainer = containers.find((container) => {
    const collectionUrl = container.getAttribute('collection_url');
    const collectionHandle = normalizeCollectionKey(
      normalizeCollectionBaseUrl(collectionUrl).split('/').filter(Boolean).pop()
    );

    return allowedHandles.includes(collectionHandle);
  });

  if (!targetContainer) {
    return false;
  }

  containers.forEach((container) => {
    container.classList.add('hidden-nav');
  });
  targetContainer.classList.remove('hidden-nav');

  return true;
};

const forceDesktopCollectionDropdown = () => {
  if (!dropdownWrapper || !dropdownContents || !isDesktop() || !hasForcedDesktopCollection()) {
    return false;
  }

  const didActivateCollection = activateContainerByCollectionKey(forcedDesktopCollection);
  if (!didActivateCollection) {
    return false;
  }

  showDesktopDropdown(true);
  setAllProductsState(false);
  setBergainsState(false);
  setCosmeticsState(false);
  dropdownWrapper.classList.add('navigationdropdown__wrapper--force-visible');
  return true;
};

const showForcedDesktopDropdown = () => {
  if (forceAllProductsDropdown) {
    return forceDesktopAllProductsDropdown();
  }

  if (forceBergainsDropdown) {
    return forceDesktopBergainsDropdown();
  }

  if (forceCosmeticsDropdown) {
    return forceDesktopCosmeticsDropdown();
  }

  if (hasForcedDesktopCollection()) {
    return forceDesktopCollectionDropdown();
  }

  return false;
};

const hideDesktopDropdown = () => {
  if (!dropdownWrapper || !isDesktop()) {
    return;
  }
  if (showForcedDesktopDropdown()) {
    return;
  }
  dropdownWrapper.classList.add('navigationdropdown__wrapper--hidden');
  dropdownWrapper.classList.remove('navigationdropdown__wrapper--no-sidebar');
  setAllProductsState(false);
  setBergainsState(false);
  setCosmeticsState(false);
};

const hideAllCollectionContainers = () => {
  if (!dropdownWrapper) {
    return;
  }
  dropdownWrapper.querySelectorAll('.collection-container').forEach((container) => {
    container.classList.add('hidden-nav');
  });
};

const activateContainerByLink = (linkUrl) => {
  if (!dropdownWrapper || !linkUrl) {
    return;
  }
  const normalizedLinkUrl = normalizeCollectionBaseUrl(linkUrl);
  const containers = Array.from(dropdownWrapper.querySelectorAll('.collection-container'));
  const fallbackContainer = containers.find((container) => {
    return normalizeCollectionBaseUrl(container.getAttribute('collection_url')) === normalizedLinkUrl;
  });

  // Bez pasującego kontenera ukrywamy wszystkie, żeby nie został widoczny kontener poprzedniej kolekcji.
  containers.forEach((container) => {
    container.classList.add('hidden-nav');
  });
  if (fallbackContainer) {
    fallbackContainer.classList.remove('hidden-nav');
  }
};

if (linkNavi) {
  linkNavi.addEventListener('mouseenter', function () {
    clearTimeout(headerHideTimeout);
    if (showForcedDesktopDropdown()) {
      return;
    }
    dataLayerPromise({
      event: 'navigation_interaction',
      section: 'top_bar',
      element: 'text_button',
      element_value: 'Produkty',
      interaction_type: 'hover',
    });
    showDesktopDropdown(true);
    setAllProductsState(true);
    hideAllCollectionContainers();
  });

  linkNavi.addEventListener('mouseleave', function () {
    headerHideTimeout = setTimeout(() => {
      hideDesktopDropdown();
    }, 200);
  });
}

if (linkBergainsNavi) {
  linkBergainsNavi.addEventListener('mouseenter', function () {
    clearTimeout(headerHideTimeout);
    if (showForcedDesktopDropdown()) {
      return;
    }
    dataLayerPromise({
      event: 'navigation_interaction',
      section: 'top_bar',
      element: 'text_button',
      element_value: 'Okazje',
      interaction_type: 'hover',
    });
    showDesktopDropdown(true);
    setBergainsState(true);
    hideAllCollectionContainers();
  });

  linkBergainsNavi.addEventListener('mouseleave', function () {
    headerHideTimeout = setTimeout(() => {
      hideDesktopDropdown();
    }, 200);
  });
}

if (linkCosmeticsNavi) {
  linkCosmeticsNavi.addEventListener('mouseenter', function () {
    clearTimeout(headerHideTimeout);
    if (showForcedDesktopDropdown()) {
      return;
    }
    dataLayerPromise({
      event: 'navigation_interaction',
      section: 'top_bar',
      element: 'text_button',
      element_value: 'Kosmetyki',
      interaction_type: 'hover',
    });
    showDesktopDropdown(true);
    setCosmeticsState(true);
    hideAllCollectionContainers();
  });

  linkCosmeticsNavi.addEventListener('mouseleave', function () {
    headerHideTimeout = setTimeout(() => {
      hideDesktopDropdown();
    }, 200);
  });
}

if (dropdownOverlay) {
  dropdownOverlay.addEventListener('mouseenter', function () {
    hideDesktopDropdown();
  });
}

if (dropdownInner) {
  dropdownInner.addEventListener('mouseenter', function () {
    clearTimeout(headerHideTimeout);
    const keepSidebarHidden = dropdownWrapper.classList.contains('navigationdropdown__wrapper--no-sidebar');
    showDesktopDropdown(keepSidebarHidden);
  });
}

if (dropdownWrapper) {
  dropdownWrapper.addEventListener('mouseleave', function (event) {
    if (!dropdownWrapper.contains(event.relatedTarget)) {
      hideDesktopDropdown();
    }
  });
}

headerLinks.forEach((link) => {
  link.addEventListener('mouseenter', () => {
    clearTimeout(headerHideTimeout);
    if (link.dataset.hideCollection === 'true') {
      hideDesktopDropdown();
      return;
    }
    if (showForcedDesktopDropdown()) {
      return;
    }
    showDesktopDropdown(true);
    setAllProductsState(false);
    setBergainsState(false);
    setCosmeticsState(false);
    const linkUrl = link.getAttribute('data-link') || link.getAttribute('href');
    activateContainerByLink(linkUrl);
  });

  link.addEventListener('mouseleave', () => {
    headerHideTimeout = setTimeout(() => {
      hideDesktopDropdown();
    }, 200);
  });
});

if (forceAllProductsDropdown || forceBergainsDropdown || forceCosmeticsDropdown || hasForcedDesktopCollection()) {
  showForcedDesktopDropdown();
  window.addEventListener('resize', () => {
    if (isDesktop()) {
      showForcedDesktopDropdown();
    }
  });
}

const navigationWrapper = document.querySelector('.navigationdropdown__wrapper.mobile_nav');
const iconLogo = document.querySelector('.icon-hamburger.open_navi');
const hamburgerTrigger = iconLogo || document.querySelector('.header__hamburger-menu');
const iconsCloseMobile = document.querySelectorAll('.icon-close_mobile');
const overlayMobile = document.querySelector('.navigation__mobile-modal__overlay');
const bodyElement = document.body;
const topbarElement = document.querySelector('.topbar');

const escapeHtml = (value) =>
  String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

const buildFilterLink = (collectionUrl, paramName, paramValue) => {
  const basePath = normalizeCollectionBaseUrl(collectionUrl);
  const params = new URLSearchParams();
  params.set(paramName, paramValue);
  return `${basePath}?${params.toString()}`;
};

const shouldIncludeMobileFilterGroup = (paramName) => {
  if (!paramName) return false;
  return (
    paramName.includes('filters_subcategories') ||
    paramName.includes('filters_needs') ||
    paramName.includes('product_line')
  );
};

const buildMobileFiltersMarkupFromCollectionDoc = (doc, collectionUrl) => {
  const filters = [];
  let filterGroupIndex = 0;
  const filterNodes = doc.querySelectorAll('#FacetFiltersForm .js-filter');

  filterNodes.forEach((filterNode) => {
    const summaryLabel = filterNode.querySelector('summary .label')?.textContent?.trim();
    if (!summaryLabel) return;
    const displaySummaryLabel = summaryLabel.toLowerCase() === 'podkategorie' ? 'Krok w pielęgnacji' : summaryLabel;

    const firstInput = filterNode.querySelector('input[type="checkbox"]');
    const paramName = firstInput?.name || '';
    if (!shouldIncludeMobileFilterGroup(paramName)) return;

    const items = [];
    const inputs = filterNode.querySelectorAll('input[type="checkbox"]');
    inputs.forEach((input) => {
      if (!input.name || !input.value || input.disabled) return;

      const label = (input.dataset.label || input.value || '').trim();
      if (!label) return;

      if (input.name.includes('filters_subcategories')) {
        const normalized = label.toLowerCase();
        if (normalized === 'wszystkie' || normalized === 'wszystkie produkty') return;
      }

      const count = input.closest('label')?.querySelector('.facet__label .count')?.textContent?.trim() || '';
      const href = buildFilterLink(collectionUrl, input.name, input.value);
      items.push(
        `<li class="mobile_filter_item"><a href="${escapeHtml(href)}" class="mobile_filter_link"><span>${escapeHtml(
          label
        )}</span>${count ? `<span class="mobile_filter_count">${escapeHtml(count)}</span>` : ''}</a></li>`
      );
    });

    if (!items.length) return;
    filterGroupIndex += 1;
    const openAttr = filterGroupIndex === 1 ? ' open' : '';

    filters.push(
      `<details class="menu-accordion" data-type="mobile-collection-filters"${openAttr}><summary class="menu-accordion__summary"><span class="text-[11px] font-semibold leading-[13.2px] uppercase tracking-[1.76px] text-text-secondary">${escapeHtml(
        displaySummaryLabel
      )}</span><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-chevron-down" aria-hidden="true" focusable="false" width="24" height="24" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.3536 16.3536C12.1583 16.5488 11.8417 16.5488 11.6464 16.3536L3.64645 8.35355C3.45118 8.15829 3.45118 7.84171 3.64645 7.64645C3.84171 7.45119 4.15829 7.45119 4.35355 7.64645L12 15.2929L19.6464 7.64645C19.8417 7.45118 20.1583 7.45118 20.3536 7.64645C20.5488 7.84171 20.5488 8.15829 20.3536 8.35355L12.3536 16.3536Z" /></svg></summary><ul class="mobile_filter_list list-unstyled" role="list">${items.join(
        ''
      )}</ul></details>`
    );
  });

  if (!filters.length) return '';
  return `<div class="mobile_filters_container">${filters.join('')}</div>`;
};

const getMobileFiltersSkeletonMarkup = () =>
  `<div class="mobile_filters_skeleton" aria-hidden="true">
    <div class="mobile_filters_skeleton_row"></div>
    <div class="mobile_filters_skeleton_row"></div>
    <div class="mobile_filters_skeleton_row"></div>
  </div>`;

const showMobileFiltersSkeleton = (container) => {
  if (!container || container.querySelector('.mobile_filters_container')) return;
  const anchor = container.querySelector('.mobile_all_products_container');
  if (!anchor || container.querySelector('.mobile_filters_skeleton')) return;
  anchor.insertAdjacentHTML('afterend', getMobileFiltersSkeletonMarkup());
};

const hideMobileFiltersSkeleton = (container) => {
  const skeleton = container?.querySelector('.mobile_filters_skeleton');
  if (skeleton) {
    skeleton.remove();
  }
};

const hydrateMobileCollectionFilters = async (container) => {
  if (!container || container.dataset.filtersHydrated === 'true' || container.dataset.filtersHydrated === 'loading') {
    return;
  }

  if (container.querySelector('.mobile_filters_container')) {
    container.dataset.filtersHydrated = 'true';
    return;
  }

  const collectionUrl = container.getAttribute('data-collection-url');
  if (!collectionUrl) return;

  container.dataset.filtersHydrated = 'loading';
  showMobileFiltersSkeleton(container);

  try {
    const response = await fetch(normalizeCollectionBaseUrl(collectionUrl), { credentials: 'same-origin' });
    if (!response.ok) throw new Error(`Failed to load collection filters: ${response.status}`);

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const filtersMarkup = buildMobileFiltersMarkupFromCollectionDoc(doc, collectionUrl);

    if (filtersMarkup) {
      const skeleton = container.querySelector('.mobile_filters_skeleton');
      if (skeleton) {
        skeleton.outerHTML = filtersMarkup;
      } else {
        const anchor = container.querySelector('.mobile_all_products_container');
        if (anchor) {
          anchor.insertAdjacentHTML('afterend', filtersMarkup);
        }
      }
    } else {
      hideMobileFiltersSkeleton(container);
    }

    container.dataset.filtersHydrated = 'true';
  } catch (error) {
    hideMobileFiltersSkeleton(container);
    container.dataset.filtersHydrated = 'error';
  }
};

const mobileAccordionAnimationDuration = 240;
const mobileAccordionAnimationEasing = 'cubic-bezier(0.33, 1, 0.68, 1)';
const mobileAccordionAnimations = new WeakMap();

const getMobileAccordionContent = (accordion) => accordion?.querySelector('.mobile_filter_list');

const stopMobileAccordionAnimation = (accordion) => {
  const currentAnimation = mobileAccordionAnimations.get(accordion);
  if (!currentAnimation) return getMobileAccordionContent(accordion);

  const { content, handleTransitionEnd, timeoutId } = currentAnimation;
  content.removeEventListener('transitionend', handleTransitionEnd);
  window.clearTimeout(timeoutId);
  content.style.transition = 'none';
  content.style.height = `${content.offsetHeight}px`;
  content.style.opacity = getComputedStyle(content).opacity;
  mobileAccordionAnimations.delete(accordion);

  return content;
};

const cleanupMobileAccordionAnimation = (accordion, content, shouldOpen) => {
  content.style.removeProperty('height');
  content.style.removeProperty('opacity');
  content.style.removeProperty('overflow');
  content.style.removeProperty('pointer-events');
  content.style.removeProperty('transition');

  accordion.open = shouldOpen;
  mobileAccordionAnimations.delete(accordion);
};

const animateMobileAccordion = (accordion, shouldOpen) => {
  const content = stopMobileAccordionAnimation(accordion);
  if (!content) {
    accordion.open = shouldOpen;
    return;
  }

  const wasOpen = accordion.open;
  if (shouldOpen) {
    accordion.open = true;
  }

  const startHeight = shouldOpen ? (wasOpen ? content.offsetHeight : 0) : content.offsetHeight || content.scrollHeight;
  const endHeight = shouldOpen ? content.scrollHeight : 0;
  const startOpacity = parseFloat(getComputedStyle(content).opacity) || (shouldOpen && !wasOpen ? 0 : 1);
  const endOpacity = shouldOpen ? 1 : 0;

  content.style.overflow = 'hidden';
  content.style.pointerEvents = 'none';
  content.style.height = `${startHeight}px`;
  content.style.opacity = `${startOpacity}`;
  content.offsetHeight;

  const handleTransitionEnd = (event) => {
    if (event.target !== content || event.propertyName !== 'height') return;
    cleanupMobileAccordionAnimation(accordion, content, shouldOpen);
  };

  const timeoutId = window.setTimeout(() => {
    cleanupMobileAccordionAnimation(accordion, content, shouldOpen);
  }, mobileAccordionAnimationDuration + 60);

  mobileAccordionAnimations.set(accordion, { content, handleTransitionEnd, timeoutId });
  content.addEventListener('transitionend', handleTransitionEnd);

  requestAnimationFrame(() => {
    content.style.transition = `height ${mobileAccordionAnimationDuration}ms ${mobileAccordionAnimationEasing}, opacity 180ms ease`;
    content.style.height = `${endHeight}px`;
    content.style.opacity = `${endOpacity}`;
  });
};

const closeSiblingMobileAccordions = (openedAccordion) => {
  const accordionContainer = openedAccordion?.closest('.mobile_filters_container');
  if (!accordionContainer) return;

  accordionContainer
    .querySelectorAll('.menu-accordion[open][data-type="mobile-collection-filters"]')
    .forEach((accordion) => {
      if (accordion !== openedAccordion) {
        animateMobileAccordion(accordion, false);
      }
    });
};

const mobileProductTitleSelector = '.mobile_products_container-inner .mobile_products .product_title';
const mobileProductTitleMaxHeight = 56;

const applyMobileProductTitleThreeLinesClass = (titleElement) => {
  if (!titleElement) return;
  titleElement.classList.toggle('three-lines', titleElement.scrollHeight > mobileProductTitleMaxHeight);
};

const handleMobileProductTitles = (scope = document) => {
  if (!scope) return;
  const productTitles = scope.querySelectorAll(mobileProductTitleSelector);
  productTitles.forEach((titleElement) => applyMobileProductTitleThreeLinesClass(titleElement));
};

const triggerMobileFilterAccordionDataLayerEvent = (accordion, action) => {
  if (typeof dataLayerPromise !== 'function' || !accordion) return;

  const accordionLabel = accordion.querySelector('.menu-accordion__summary span')?.textContent?.trim() || '';
  const elementValue = accordion.querySelector('a[data-categories]')?.getAttribute('data-categories') || '';

  dataLayerPromise({
    event: 'navigation_interaction',
    section: 'menu_second_level',
    element: action,
    element_value: elementValue,
    sub_menu_category: accordionLabel,
    interaction_type: 'click',
  });
};

navigationWrapper?.addEventListener('click', (event) => {
  const summary = event.target.closest('.menu-accordion__summary');
  if (!summary || !navigationWrapper.contains(summary)) return;

  const accordion = summary.closest('.menu-accordion[data-type="mobile-collection-filters"]');
  if (!(accordion instanceof HTMLDetailsElement)) return;

  event.preventDefault();

  if (accordion.open) {
    triggerMobileFilterAccordionDataLayerEvent(accordion, 'close_dropdown');
    animateMobileAccordion(accordion, false);
    return;
  }

  triggerMobileFilterAccordionDataLayerEvent(accordion, 'open_dropdown');
  closeSiblingMobileAccordions(accordion);
  animateMobileAccordion(accordion, true);
});

if (hamburgerTrigger) {
  hamburgerTrigger.addEventListener('click', function () {
    if (typeof dataLayerPromise === 'function') {
      dataLayerPromise({
        event: 'navigation_interaction',
        section: 'top_bar',
        element: 'text_button',
        element_value: 'Produkty',
        interaction_type: 'click',
      });
    }

    if (navigationWrapper) {
      const topbarHeight = topbarElement ? topbarElement.offsetHeight : 0;
      navigationWrapper.style.top = `${topbarHeight}px`;
      navigationWrapper.style.setProperty('--mobile-nav-offset', `${topbarHeight}px`);
      navigationWrapper.classList.add('opened');
    }
    overlayMobile?.classList.add('show');
    bodyElement.style.overflow = 'hidden';
    requestAnimationFrame(() => handleMobileProductTitles(navigationWrapper));
  });
}

iconsCloseMobile.forEach(function (iconCloseMobile) {
  iconCloseMobile.addEventListener('click', function () {
    navigationWrapper.classList.remove('opened');
    overlayMobile.classList.remove('show');
    bodyElement.style.overflow = 'auto';
    const containers = document.querySelectorAll('.mobile_products_container');
    containers.forEach(function (container) {
      container.classList.remove('opened');
    });
  });
});

const handleWindowResize = () => {
  if (navigationWrapper && window.innerWidth <= 1023) {
    const topbarHeight = topbarElement ? topbarElement.offsetHeight : 0;
    navigationWrapper.style.top = `${topbarHeight}px`;
    navigationWrapper.style.setProperty('--mobile-nav-offset', `${topbarHeight}px`);
  }

  if (window.innerWidth >= 1024) {
    if (navigationWrapper) {
      navigationWrapper.classList.remove('opened');
      navigationWrapper.style.top = '';
      navigationWrapper.style.removeProperty('--mobile-nav-offset');
    }
    overlayMobile?.classList.remove('show');
  }

  handleMobileProductTitles(navigationWrapper);
};

window.addEventListener('resize', handleWindowResize);

handleWindowResize();
requestAnimationFrame(() => handleMobileProductTitles(navigationWrapper));

if (document.fonts?.ready) {
  document.fonts.ready.then(() => handleMobileProductTitles(navigationWrapper));
}

if (overlayMobile) {
  overlayMobile.addEventListener('click', function () {
    navigationWrapper?.classList.remove('opened');
    overlayMobile.classList.remove('show');
    bodyElement.style.overflow = 'auto';
  });
}

const categoryItemsMobile = document.querySelectorAll(
  '.navigationdropdown__wrapper.mobile_nav .categorieslist__list-item'
);

categoryItemsMobile.forEach(function (item) {
  item.addEventListener('click', function (event) {
    if (item.dataset.hideCollection === 'true') {
      return;
    }

    const hasHashLink = Array.from(item.querySelectorAll('a')).some((link) => link.getAttribute('href') === '#');

    if (hasHashLink) {
      const containers = document.querySelectorAll('.mobile_products_container');
      containers.forEach(function (container) {
        container.classList.remove('opened');
      });

      const nearestContainer = item.nextElementSibling;
      if (nearestContainer && nearestContainer.classList.contains('mobile_products_container')) {
        hydrateMobileCollectionFilters(nearestContainer);
        nearestContainer.scrollIntoView({ block: 'start' });
        nearestContainer.classList.add('opened');
        requestAnimationFrame(() => handleMobileProductTitles(nearestContainer));
      }

      event.preventDefault();
    }
  });
});

const backIcons = document.querySelectorAll('.mobile-modal__back-container');

backIcons.forEach(function (backIcon) {
  backIcon.addEventListener('click', function () {
    let containers = document.querySelectorAll('.mobile_products_container');
    containers.forEach(function (container) {
      container.classList.remove('opened');
    });
    const activeItems = document.querySelectorAll('.categorieslist__list-item.categorieslist__list-item--active');
    if (activeItems.length > 0) {
      activeItems.forEach(function (item) {
        item.classList.remove('categorieslist__list-item--active');
      });
    }
  });
});

const topbarDesktopLogo = document.querySelector('.header__logo.desktop-logo a');
const topbarMobileLogo = document.querySelector('.header__logo.mobile-logo a');

const logotypeEventData = {
  event: 'navigation_interaction',
  device_type: typeof deviceType !== 'undefined' ? deviceType : '',
  user_id: window.customerData?.id ? window.customerData?.id : '',
  section: 'top_bar',
  element: 'logo_button',
  element_value: 'your_kaya',
  interaction_type: 'click',
};
if (topbarDesktopLogo) {
  topbarDesktopLogo.addEventListener('click', async (e) => {
    e.preventDefault();
    await dataLayerPromise(logotypeEventData);
    continueLinkClickEvent(e, topbarDesktopLogo.href);
  });
}
if (topbarMobileLogo) {
  topbarMobileLogo.addEventListener('click', async (e) => {
    e.preventDefault();
    await dataLayerPromise(logotypeEventData);
    continueLinkClickEvent(e, topbarMobileLogo.href);
  });
}
